"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { AppSidebar } from "@/components/blocks/AppSidebar";
import Logo from "@/components/brand/Logo";
import { SidebarHeaderBar } from "@/components/layouts/SidebarHeaderBar";
import { Separator } from "@/components/ui/separator";
import { SidebarInset, SidebarProvider, SidebarTrigger } from "@/components/ui/sidebar";
export function SidebarLayout(t0) {
  const $ = _c(10);
  const {
    children,
    defaultOpen
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <AppSidebar />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  let t4;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <SidebarTrigger size="icon-lg" className="-ml-2 shrink-0" />;
    t3 = <Separator orientation="vertical" className="shrink-0 px-0 data-vertical:h-6 data-vertical:self-center" />;
    t4 = <SidebarHeaderBar />;
    $[1] = t2;
    $[2] = t3;
    $[3] = t4;
  } else {
    t2 = $[1];
    t3 = $[2];
    t4 = $[3];
  }
  let t5;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <header data-app-header={true} className="sticky top-0 z-40 shrink-0 border-b bg-background/95 backdrop-blur supports-[backdrop-filter]:bg-background/80"><div className="flex min-h-16 w-full items-center gap-2 px-4 py-3 sm:px-6 md:gap-4 lg:px-8">{t2}{t3}{t4}<Link href="/" aria-label="Clutch home" className="ml-auto flex shrink-0 items-center rounded-xl pr-1 text-foreground outline-hidden ring-ring/60 transition-opacity hover:opacity-85 focus-visible:ring-2"><Logo variant="text" size="md" className="hidden text-lg sm:inline-flex" /><Logo variant="logo" size="xl" className="text-base sm:hidden" /></Link></div></header>;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== children) {
    t6 = <SidebarInset data-sidebar-shell={true} className="min-w-0">{t5}<div data-sidebar-shell-content={true} className="flex min-w-0 flex-1 flex-col px-4 sm:px-6 lg:px-8">{children}</div></SidebarInset>;
    $[5] = children;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== defaultOpen || $[8] !== t6) {
    t7 = <SidebarProvider defaultOpen={defaultOpen}>{t1}{t6}</SidebarProvider>;
    $[7] = defaultOpen;
    $[8] = t6;
    $[9] = t7;
  } else {
    t7 = $[9];
  }
  return t7;
}